import React from 'react';
import PropTypes from 'prop-types';
import { Button, Radio } from 'adp-react-components';
import {
  loadHttpHeaders,
  loadAjaxBody,
  getOtpDevicePosition
} from './../../../components/utils/utils.js';

class OtpDevices extends React.Component {
  constructor(props) {
    console.log('constructor initialized for otp-devices');
    super(props);
    this.state = {
      otps: {},
      otpSelectedValue: '',
      otpSelectedPosition: ''
    };
    console.log('wizard ---->' + this.props.stepupOtpDevices.mailid);
    this.onChangeHandle.bind(this);
  }

  componentWillMount() {
    this.setState({
      otps: this.props.stepupOtpDevices
    });
    console.log('componentWillMount initialized for stepup-delivery-method');
  }

  onChangeHandle(keyItem, valueItem, event) {
      this.props.showErrorMessage('');
    console.log('event: key : ' + keyItem);
    console.log('event: value : ' + valueItem);
    const position = getOtpDevicePosition(keyItem);
    console.log('position : ' + position);
    this.setState({
      otpSelectedValue: valueItem,
      otpSelectedPosition: position
    });
    this.props.fetchDeliveryMethod(valueItem);
    console.log('this.state.otpSelectedValue:' + valueItem);
  }

  onSubmit(event) {
      this.props.showErrorMessage('');
    console.log('this.state.selectedValue' + this.state.otpSelectedValue);
    this.props.stepupOtpDevicesMethod(this.props.stepupOtpDevices);
    console.log('otpSelectedPosition state::' + this.state.otpSelectedPosition);

    fetch(context+'/enroll/adpPassword.faces?stepupSelectionAjaxForm', {
      method: 'POST',
      credentials: 'same-origin',
      headers: loadHttpHeaders(),
      body: loadAjaxBody(
        'stepupSelectionAjaxForm',
        'otpType=' + this.state.otpSelectedPosition
      )
    })
      .then(response => {
        return response.json();
      })
      .then(data => {
        if (data.success == 'false' || data.success == false) {
          if (data.wizard.message == 'true') {
            this.props.showSessionExpired();
            return;
          }
          this.props.showErrorMessage(data.wizard.message);
          return;
        }
        if (data.success == 'true' || data.success == true) {
          if (
            (data.challengeMode == 'HIGH' &&
              this.state.otpSelectedPosition == '0') ||
            (data.challengeMode == 'MEDIUM' &&
              this.state.otpSelectedPosition == 'Q')
          ) {
            if (data.challengeMode == 'HIGH') {
              this.props.fetchChallengeMode(true);
            }
            this.props.showChallengeQna(true);
          } else {
            this.props.showOtpVerificationCode(true);
          }
        }
      });
  }

  isSeletedRadio(value) {
    return value != '';
  }
  handleEnterKeyPress(e) {

    if (this.isSeletedRadio(this.state.otpSelectedValue) && e.charCode == 13) {
      e.preventDefault(); //preventing html5 default form submit
      this.onSubmit();
    }
  }

  render() {
    let isValid = this.isSeletedRadio(this.state.otpSelectedValue);
    return (
      <div className="vdl-row login-form">
        <div className="vdl-col-md-12">
          <div className="form-group">
            {Object.keys(this.state.otps).map(keyItem => {
              const valueItem = this.state.otps[keyItem];
              if (valueItem != '') {
                return (
                  <Radio
                    value={valueItem}
                    onKeyPress={this.handleEnterKeyPress.bind(this)}
                    key={keyItem}
                    className="vdl-radio-custom-text"
                    radioGroupValue={this.state.otpSelectedValue}
                    onChange={e => this.onChangeHandle(keyItem, valueItem, e)}>
                    {' '}
                    {valueItem}{' '}
                  </Radio>
                );
              }
            })}
            {!this.props.challengeModeHigh ? (
              <Radio
                value={this.props.stepupSelectQnaOnly}
                onKeyPress={this.handleEnterKeyPress.bind(this)}
                key={'Q'}
                className="vdl-radio-custom-text"
                radioGroupValue={this.state.otpSelectedValue}
                onChange={e =>
                  this.onChangeHandle('Q', this.props.stepupSelectQnaOnly, e)
                }>
                {' '}
                {this.props.stepupSelectQnaOnly}{' '}
              </Radio>
            ) : null}
          </div>
          <div className="form-group submit vdl-text-xs-center">
            <Button
              className="primary"
              disabled={!isValid}
              onClick={this.onSubmit.bind(this)}>
              {' '}
              {this.props.sendcode}
            </Button>
          </div>{' '}
          {/* form-group submit vdl-text-xs-center */}
        </div>{' '}
        {/* vdl-col-md-12 */}
      </div>
    );
  }
}
OtpDevices.propTypes = {
  stepupOtpDevices: PropTypes.object
};

OtpDevices.getDefaultProps = {
  stepupOtpDevices: undefined
};

export default OtpDevices;



// WEBPACK FOOTER //
// ./src/scenes/admin-login/stepup/otp-devices.js